if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.index = this.dataset.itemIndex; /* Index of the product in a product grid */
      this.enableScrollIntercept = this.dataset.scrollIntercept === 'true'; /* Enable scroll intercept for quick buy button */

      // comment this in for js fetch of swatch product into current product card
      // this.handleProductCardSwatchClick();
      // this.handleSwymWishlistButtonClick();

      if (this.enableScrollIntercept) {
        this.addEventListener('click', (event) => {
          this.linkIntercept(event);
        });
      }

      this.querySelector('.product-card__heading a')?.addEventListener('click', (event) => {

        let itemData = this.querySelector('template').innerHTML;
        itemData = JSON.parse(itemData);
        itemData.index = parseInt(this.index);

        document.dispatchEvent(new CustomEvent('product-card:selected', {
          detail: {
            action: 'select_item',
            location: 'PCP Collection',
            item: itemData
          }
        }));
      });

      const self = this;

        self.setHoverImageStyle();


      window.addEventListener('load', () => {
        this.handleImageDisplayNone();
      });

      // Elevar
      this.productCardDataTemplate = this.querySelector('template');
      this.elevarTemplate = document.querySelector('#elevar-atc-custom-data');
      this.quickBuyButton = this.querySelector('quickbuy-button') || this.querySelector('product-form');

      if (this.productCardDataTemplate && this.elevarTemplate && this.quickBuyButton) {
        this.quickBuyButton.addEventListener('click', () => {
          this.updateElevarTemplateData();
        });
      }
    }

    setHoverImageStyle() {
      const image = this.querySelector('.product-card__image[style*="display: none"]');
      if (image) {
        image.style.removeProperty('display');
      }
    }

    handleImageDisplayNone() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // const lazyloadImages = entry.target.querySelectorAll('img[loading="lazy"]');
            // lazyloadImages.forEach((img) => {
            //   img.setAttribute('loading', 'eager');
            // });

            const image = entry.target.querySelector('.product-card__image[style*="display: none"]');
            if (image) {
              image.style.removeProperty('display');
              observer.unobserve(entry.target);
            }
          }
        });
      });

      observer.observe(this);
    }

    handleSwymWishlistButtonClick() {
      const wishlistButton = this.querySelector(".swym-add-to-wishlist-view-product");
      wishlistButton?.addEventListener("click", (event) => {
        if (wishlistButton.classList.contains("swym-added")) {
          wishlistButton.classList.remove("animate--adding");
        } else {
          wishlistButton.classList.add("animate--adding");
        }
      });
    };

    handleInsideLinkClick = (event) => {
      event.preventDefault();
    };

    fetchProduct(event) {
      event.preventDefault();

      const isWithinSlider = this.closest("slider-component") !== null;
      const isWithinCartDrawer = this.closest("cart-drawer") !== null;
      const isProductPage = document.body.classList.contains("product");
      const isMobile = window.innerWidth < 750;

      fetch(event.target.dataset.productUrl + "?view=card-product--swatches")
        .then((response) => response.text())
        .then((text) => {
          const newHtml = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("product-card").innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll(
        "product-group product-group-swatch"
      );
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", this.fetchProduct.bind(this));
        swatch.querySelector("a.product-group--item")?.classList.add("js-load");
        swatch
          .querySelector("a.product-group--item")
          ?.addEventListener("click", this.handleInsideLinkClick);
      });
    }

    updateElevarTemplateData() {

      if (!this.elevarTemplate || !this.productCardDataTemplate) return;

      const productCardData = JSON.parse(this.productCardDataTemplate.innerHTML);
      const elevarData = JSON.parse(this.elevarTemplate.innerHTML);

      elevarData.product_mid = productCardData.mid;
      elevarData.product_team = productCardData.team;
      elevarData.product_silhouette = productCardData.silhouette;
      elevarData.product_license = productCardData.sport;
      elevarData.country = productCardData.market;

      this.elevarTemplate.innerHTML = JSON.stringify(elevarData);
    }

    linkIntercept(event) {
      if (event.target.closest('quickbuy-button') || event.target.closest('product-form') || event.target.closest('.product-card__wishlist-button') || event.target.closest('.price__badge-members-only')) {
        return;
      } else if (event.target.closest('product-card') && event.target.closest('#product-grid')) {
        event.preventDefault();
        const variantID = event.target.closest('li.grid__item').dataset.variantId;
        const collectionHandle = event.target.closest('#product-grid').dataset.collectionHandle;

        if ( variantID && collectionHandle ) {
          this.setLastVisitedProductInSessionStorage(variantID, collectionHandle);
        }

        window.location.href = event.target.closest('product-card').querySelector('a').href;
      }
    }

    setLastVisitedProductInSessionStorage(variantID, collectionHandle) {
      sessionStorage.setItem("lastVisitedProduct", JSON.stringify({ variantID, collectionHandle }));
    }
  }

  customElements.define("product-card", ProductCard);
}